import { render, staticRenderFns } from "./ScanTask.vue?vue&type=template&id=28e6ee84&scoped=true&"
import script from "./ScanTask.vue?vue&type=script&lang=js&"
export * from "./ScanTask.vue?vue&type=script&lang=js&"
import style0 from "./ScanTask.vue?vue&type=style&index=0&id=28e6ee84&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e6ee84",
  null
  
)

export default component.exports